import { render, staticRenderFns } from "./AccessListView.vue?vue&type=template&id=979bbc0c&scoped=true"
import script from "./AccessListView.vue?vue&type=script&lang=js"
export * from "./AccessListView.vue?vue&type=script&lang=js"
import style0 from "./AccessListView.vue?vue&type=style&index=0&id=979bbc0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979bbc0c",
  null
  
)

export default component.exports